import { Switch, Table, notification } from "antd";
import React, { useEffect, useState } from "react";
import { ToastCrossIcon } from "../../constants/svg";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAutomations,
  UpdateAutomations,
} from "../../services/team/automations";
import {
  setIsAutomationsLoading,
  setAutomations,
  updateAutomations,
} from "../../store/slices/rewardSlice";
import { status, tableHeight } from "../../utils/constants";
import moment from "moment";
import { GetAuthUserLocalStorage } from "../../services/localStorage/localStorage";
import { tableLoader, toastMessage } from "../../utils/helper";

const AutomationPage = () => {
  const dispatch = useDispatch();
  const { currentSalonId } = useSelector((state) => state.global);
  const { isAutomationsLoading, automations } = useSelector(
    (state) => state?.reward,
  );

  const [page, setPage] = useState({ currentPage: 1, perPage: 10 });

  const handleSwitchChange = async (record, checked) => {
    try {
      dispatch(
        updateAutomations({ index: record?.index, checkedValue: checked }),
      );
      const payload = {
        status: checked ? status?.active : status?.inactive,
        shoutout_id: record?.key,
        salon_id: currentSalonId,
        type: record?.type,
      };
      const response = await UpdateAutomations(payload);

      const { data, message, status: responseStatus } = response.data;
      if (!responseStatus) {
        toastMessage("error", message);
        return;
      }

      toastMessage("success", "Status changed successfully!");
    } catch (e) {
      notification.error({
        description: e.message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
    }
  };

  const columns = [
    {
      title: "Message Preview",
      dataIndex: "message",
      key: "message",
      width: "60%",
      render: (text) => (
        <>
          <div className="newmessageBox">
            <h5>{text.subheading}</h5>
            <p>{text.paragraph}</p>
          </div>
        </>
      ),
    },
    {
      title: "Send On",
      dataIndex: "sendOn",
      key: "sendOn",
      width: "30%",
      render: (text) => (
        <>
          <h5>{text.heading}</h5>
          <p>{text.paragraph}</p>
        </>
      ),
    },
    // {
    //   title: "On Click",
    //   dataIndex: "onClick",
    //   key: "onClick",
    //   render: (text) => (
    //     <>
    //       <h5>{text.heading}</h5>
    //       <h6>{text.subheading}</h6>
    //       <p>{text.paragraph}</p>
    //     </>
    //   ),
    //   width: "234px",
    // },
    {
      title: "Off/On",
      dataIndex: "offOn",
      key: "offOn",
      width: "10%",
      render: (checked, record) => (
        <>
          <div className="d-flex align-items-start">
            <Switch
              defaultChecked={checked}
              onChange={(newChecked) => handleSwitchChange(record, newChecked)}
            />
          </div>
        </>
      ),
    },
  ];

  const fetchAutomations = async () => {
    try {
      if (automations?.data?.length == 0) {
        dispatch(setIsAutomationsLoading(true));
      }
      const params = {
        is_paginated: 1,
        page: page?.currentPage,
        "per-page": page?.perPage,
      };

      const res = await GetAutomations(params);
      const sortedData = res?.data?.data?.data?.sort((a, b) => a.type - b.type);
      const data = sortedData?.map((item, index) => {
        return {
          key: item?.id,
          index,
          message: {
            heading: item?.name || "-",
            subheading: item?.title || "-",
            paragraph: item?.description || "-",
          },
          sendOn: {
            heading: (item?.send_on?.split("\\n")[0] || "-").replace(/\\/g, ""),
            subheading: (item?.send_on?.split("\\n")[1] || "-").replace(
              /\\/g,
              "",
            ),
            paragraph:
              item?.time === "00:00:00"
                ? "Immediately"
                : moment(item?.time, "HH:mm:ss").format("hh:mm A"),
          },
          onClick: {
            heading: item?.action?.split("\n")[0] || "-",
            subheading: item?.action?.split("\n")[1] || "-",
            // paragraph: item?.description || "-",
          },
          offOn: item?.salonStatus == status?.active,
          type: item?.type,
        };
      });
      dispatch(setAutomations({ data, meta: res?.data?.data?.meta }));
      dispatch(setIsAutomationsLoading(false));
    } catch (e) {
      notification.error({
        description: e.message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
      dispatch(setIsAutomationsLoading(false));
    }
  };

  useEffect(() => {
    fetchAutomations();
  }, [page.currentPage, page?.perPage]);

  return (
    <>
      <div className="teamTabMainHead">
        <h2 className="sec-heading">Automations</h2>
      </div>
      <div className="teamTabSubHead memberHeader">
        <p>
          When enabled, these automations trigger push notifications to all
          users.&nbsp;
          <a
            href={
              "https://support.mysalonsymphony.com/hc/en-us/articles/19399244751899-Manage-Automations"
            }
            target="_blank"
            className={"uLine globalBlueLinkColor"}
            rel="noreferrer"
          >
            Learn More.
          </a>
        </p>
      </div>

      <div className="teamBody content">
        <Table
          loading={tableLoader(isAutomationsLoading)}
          dataSource={automations?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: "max-content", y: tableHeight?.teamHeightTable }}
          responsive={true}
          // pagination={{
          //   onChange: (currPage) => setPage({ ...page, currentPage: currPage }),
          //   pageSize: page?.perPage,
          //   current: page?.currentPage,
          //   total: automations?.meta?.total || 0,
          //   pageSizeOptions: [10, 20, 50, 100, 'All'],
          //   showSizeChanger: false,
          // }}
          className="automationTable"
        />
      </div>
    </>
  );
};

export default AutomationPage;
